import React, { useState, useEffect } from "react";
import {
  Box,
  Select,
  MenuItem,
  Button,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  FormHelperText,
  TextField,
  Switch,
  Tooltip,
  Grow,
  FormControlLabel,
} from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DateRange, EditOutlined } from "@material-ui/icons";
import axios from "axios";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  RemoveCircleOutlineRounded,
} from "@material-ui/icons";
import DatePicker from "../CMDatePicker";
import DateRangePickerComponent from "../CMDateRange";
const ConditionalFilter = ({
  options,
  handleAdvancedFilterSearch,
  preSelectedFilters,
  page,
  handleClose,
  fctwListShowing = false,
}) => {
  const [selectedComponent, setSelectedComponent] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [globalErrorMessage, setGlobalErrorMessage] = useState("");
  const [groups, setGroups] = useState([
    {
      logicalOperator: "AND",
      values: [],
      selectedOption: "",
      internalErrors: [],
    },
  ]);

  const [fetchedOptions, setFetchedOptions] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [checked, setChecked] = useState(false);
  const [toggleWidth, setToggleWidth] = useState(100);
  const handleChange = () => {
    setChecked((prev) => !prev);
    if (!checked) {
      setToggleWidth(70);
    } else {
      setToggleWidth(100);
    }
  };
  const fetchOptions = async (apiUrl) => {
    console.log("INSIDE FETCH OPTIONS", apiUrl);
    try {
      const response = await axios.post(apiUrl);
      const data = await response.data;
      console.log(data);
      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const addFields = (groupIndex) => {
    const updatedErrors = [...errorMessage];
    updatedErrors[groupIndex] = "";
    setErrorMessage(updatedErrors);
    const updatedGroups = [...groups];

    if (
      updatedGroups[groupIndex].values[
      updatedGroups[groupIndex].values.length - 1
      ] === null
    ) {
      updatedGroups[groupIndex].internalErrors[
        updatedGroups[groupIndex].values.length - 1
      ] = "Please enter a value";
      return false;
    }

    updatedGroups[groupIndex].values.push(null);
    setGroups(updatedGroups);
  };

  const removeFields = (groupIndex, fieldIndex) => {
    const updatedGroups = [...groups];
    if (
      fieldIndex >= 0 &&
      fieldIndex < updatedGroups[groupIndex].values.length
    ) {
      updatedGroups[groupIndex].values.splice(fieldIndex, 1);
      updatedGroups[groupIndex].internalErrors.splice(fieldIndex, 1);
      setGroups(updatedGroups);
      const currentSelectedComponentDetails = [...selectedComponent];
      const selectedGroup = currentSelectedComponentDetails[groupIndex];
      if (selectedGroup && selectedGroup.props && selectedGroup.props.values) {
        selectedGroup.props.values.splice(fieldIndex, 1);
        setSelectedComponent(currentSelectedComponentDetails);
      }
    } else {
      console.error("Invalid field index or group index.");
    }
  };

  const addGroup = (groupIndex) => {
    console.log("INSIDE ADD GROUP", selectedComponent);
    if (
      selectedComponent.length > groupIndex &&
      selectedComponent[groupIndex]
    ) {
      const currentGroup = groups[groupIndex];

      if (
        currentGroup.values.some(
          (value) => value === null || value === undefined || value === ""
        )
      ) {
        const updatedErrors = [...errorMessage];
        updatedErrors[groupIndex] = "Please enter value";
        setErrorMessage(updatedErrors);
        return false;
      } else {
        const updatedErrors = [...errorMessage];
        updatedErrors[groupIndex] = "";
        setErrorMessage(updatedErrors);
      }

      const newGroup = {
        // logicalOperator,
        values: [],
        selectedOption: "",
        internalErrors: [],
      };
      setGroups((prevGroups) => [...prevGroups, newGroup]);
    } else {
      const updatedErrors = [...errorMessage];
      updatedErrors[groupIndex] = "Please select a filter option";
      setErrorMessage(updatedErrors);
      return false;
    }
  };

  const removeGroup = (groupIndex) => {
    if (groups.length > 1) {
      const updatedGroups = [...groups];
      updatedGroups[groupIndex].values = [];
      updatedGroups[groupIndex].internalErrors = [];
      updatedGroups.splice(groupIndex, 1);
      setGroups(updatedGroups);
      const updatedSelectedComponent = [...selectedComponent];
      updatedSelectedComponent.splice(groupIndex, 1);
      setSelectedComponent(updatedSelectedComponent);
    }
  };

  const isFormValid = () => {
    for (const group of groups) {
      if (
        group.selectedOption === "" ||
        group.values.some(
          (value) => value === null || value === undefined || value === ""
        )
      ) {
        return false;
      }

      for (const internalError of group.internalErrors) {
        if (internalError !== null) {
          if (internalError === "") {
            return true;
          }
          return false;
        }
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    console.log("Groups in handleSubmit===", groups);
    if (!isFormValid(groups)) {
      setGlobalErrorMessage("Please correct the form errors before submitting");
      return;
    }
    setGlobalErrorMessage("");
    const groupAddedOptions = {};
    const result = groups.map((group, index) => {
      const groupObject = {};
      if (options[group.selectedOption].multiple) {
        groupObject[group.selectedOption] = [];
        if (!groupAddedOptions[group.selectedOption]) {
          groupAddedOptions[group.selectedOption] = [];
        }
        groupAddedOptions[group.selectedOption].push(group.values);
        groupObject[group.selectedOption] =
          groupAddedOptions[group.selectedOption];
      } else {
        if (selectedComponent[index].type === "range") {
          groupObject[group.selectedOption] = group.values[0];

          if (groupObject[group.selectedOption]) {
            groupObject[group.selectedOption].db_fields =
              options[group.selectedOption].db_fields;
          } else {
            console.error("groupObject[group.selectedOption] is undefined");
          }

          // groupObject[group.selectedOption].db_fields =
          //   options[group.selectedOption].db_fields;
        } else {
          groupObject[group.selectedOption] = group.values;
        }
      }
      return groupObject;
    });

    const mergedObject = Object.assign({}, ...result);
    console.log("Merged Object for search", mergedObject);
    handleAdvancedFilterSearch([mergedObject], groups);
  };

  const handleJSONPaste = (jsonString) => {
    try {
      const parsedFilters = JSON.parse(jsonString);

      if (Array.isArray(parsedFilters)) {
        setSelectedComponentsFromFilters(parsedFilters);
        setGroupsFromPreSelectedFilters(parsedFilters);
        if (!isFormValid(parsedFilters)) {
          setGlobalErrorMessage(
            "Please correct the form errors in the pasted JSON"
          );
        } else {
          setGlobalErrorMessage("");
        }
      } else {
        throw new Error("Invalid JSON format. Expected an array.");
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  };

  const handleGroupSelectChange = (groupIndex, eventDetails) => {
    const updatedErrors = [...errorMessage];
    updatedErrors[groupIndex] = "";
    setErrorMessage(updatedErrors);
    const updatedGroups = [...groups];
    updatedGroups[groupIndex].selectedOption = eventDetails.target.value;
    updatedGroups[groupIndex].values = [];
    updatedGroups[groupIndex].values.push(null);
    updatedGroups[groupIndex].internalErrors = [];
    updatedGroups[groupIndex].internalErrors.push(null);
    setGroups(updatedGroups);

    const selectedOption = Object.keys(options).find(
      (option) => option === eventDetails.target.value
    );

    if (selectedOption) {
      const { component, type, props } = options[selectedOption];
      const currentSelectedComponentDetails = [...selectedComponent];
      currentSelectedComponentDetails[groupIndex] = {
        component: component,
        type: type,
        props: props,
      };

      setSelectedComponent(currentSelectedComponentDetails);
    }
  };

  const setSelectedComponentsFromFilters = (filters) => {
    console.log("Setting preselected filters", filters);
    const selectedComponents = filters
      .map((filter) => {
        const { selectedOption } = filter;
        const option = options[selectedOption];

        if (option) {
          const { component, type, props } = option;
          return {
            component: component,
            type: type,
            props: props,
          };
        }

        return null;
      })
      .filter(Boolean);
    console.log("Setting these components", selectedComponents);
    setSelectedComponent(selectedComponents);
  };

  useEffect(() => {
    const loadOptions = async () => {
      const fetchedOptions = {};
      let valueToFetch = "";
      for (const key in options) {
        if (options[key].api) {
          console.log("KEY", key);
          fetchedOptions[key] = await fetchOptions(options[key].api);
          valueToFetch = key;
        }
      }
      console.log(
        "FETCHED OPTIONS",
        fetchedOptions,
        valueToFetch,
        fetchedOptions[valueToFetch]
      );
      setFetchedOptions(fetchedOptions);
    };

    loadOptions();
    if (preSelectedFilters && preSelectedFilters.length > 0) {
      console.log("Preselected filters found",preSelectedFilters);
      setSelectedComponentsFromFilters(preSelectedFilters);
      setGroupsFromPreSelectedFilters(preSelectedFilters);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preSelectedFilters, options]);

  const setGroupsFromPreSelectedFilters = (filters) => {
    const updatedGroups = filters.map((preSelectedFilterDetail) => {
      const newGroup = {
        values: preSelectedFilterDetail.values || [],
        selectedOption: preSelectedFilterDetail.selectedOption || "",
        internalErrors: Array(preSelectedFilterDetail.values.length || 0).fill(
          ""
        ),
      };
      return newGroup;
    });

    setGroups(updatedGroups);
  };

  const componentMapping = {
    Text: TextField,
    Select: (props) => {
      console.log("PROPS INSIDE SELECT", props);
      console.log("PROPS Nested", props.nested);
      console.log("FETCHEDOPTIONS inside mapping", fetchedOptions);
      const { optionKey, ...rest } = props;
      console.log("OPTIONKEY", optionKey);
      const selectOptions = fetchedOptions[optionKey] || [];
      console.log("selectOptions", selectOptions, selectOptions[0]);
      // const nestedSelect =
      //   typeof selectOptions[0] === "object" &&
      //   typeof selectOptions[0].value === "object" &&
      //   !Array.isArray(selectOptions[0].value)
      //     ? true
      //     : false;

      if (props.nested) {
        return (
          <>
            <Select {...rest} style={{ width: "200px" }}>
              {selectOptions.map((nestedOption, index) => {
                console.log("NESTED OPTION", nestedOption);
                console.log("props.nested[0]", props.nested[0]);
                return (
                  <MenuItem value={nestedOption._id} key={nestedOption._id}>
                    {`${nestedOption.value[props.nested[0]]} - ${nestedOption.value[props.nested[1]]
                      }`}
                  </MenuItem>
                );
              })}
            </Select>
          </>
        );
      } else {
        return (
          <Select {...rest} style={{ width: "200px" }}>
            {selectOptions.map((option) => {
              return typeof option === "object" ? (
                <MenuItem disabled={!fctwListShowing && option.value.includes('FCTW')} key={option._id} value={option._id}>
                  {option.value ? option.value : option.model_name}
                </MenuItem>
              ) : (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>
        );
      }
    },
    DatePicker: DatePicker,
    DateRangePicker: DateRangePickerComponent

  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={7} style={{ textAlign: "end" }}>
          <h3>Search Filters</h3>
        </Grid>

        {/* <Grid item xs={5} style={{ textAlign: "end" }}>
          <FormControlLabel
            control={<Switch checked={checked} onChange={handleChange} />}
            label="JSON Viewer"
          />
        </Grid> */}
      </Grid>

      {globalErrorMessage === "" ? null : (
        <span style={{ color: "red" }}>{globalErrorMessage}</span>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box
          style={{
            width: toggleWidth + "%",
          }}
        >
          {groups.map((group, groupIndex) => (
            <div
              key={groupIndex}
              style={{
                border: "solid 1px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "2%",
                marginBottom: "3%",
              }}
            >
              {groupIndex !== 0 ? (
                <InputLabel
                  style={{
                    color: "rgba(0, 0, 0, 0.87)",
                    padding: "9px",
                    fontWeight: 700,
                    fontSize: "16px",
                    marginTop: "-5%",
                    background: "white",
                    width: "5%",
                  }}
                >
                  AND
                </InputLabel>
              ) : null}
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <div>
                    <FormControl
                      sx={{ m: 1, minWidth: 120 }}
                      variant="outlined"
                    >
                      <Select
                        style={{ width: "300px" }}
                        value={group.selectedOption}
                        onChange={(e) => handleGroupSelectChange(groupIndex, e)}
                      >
                        {Object.keys(options).map((option) => {
                          console.log("OPTION DETAILS", option);
                          const isOptionSelected = groups.some(
                            (group) => group.selectedOption === option
                          );
                          const currentOption = options[option];
                          return (
                            <MenuItem
                              value={option}
                              key={option}
                              disabled={
                                (isOptionSelected && !currentOption.multiple) ||
                                (fctwListShowing && option === 'assessment_code')
                              }
                            >
                              {options[option].props.label}
                            </MenuItem>
                          );
                        })}
                      </Select>

                      <FormHelperText style={{ color: "red" }}>
                        {errorMessage[groupIndex]}
                      </FormHelperText>
                    </FormControl>

                    <Grid container style={{ marginTop: "5px" }}>
                      <Grid item xs={4}>
                        <Button
                          onClick={() => addGroup(groupIndex)}
                          variant="outlined"
                        >
                          Add
                        </Button>
                      </Grid>
                      {groupIndex !== 0 ? (
                        <Grid item xs={4}>
                          <Button
                            onClick={() => removeGroup(groupIndex)}
                            variant="outlined"
                            color="error"
                          >
                            Remove
                          </Button>
                        </Grid>
                      ) : null}
                    </Grid>
                  </div>
                </Grid>

                <Grid item xs={8}>
                  {group.values.map((dynamicField, fieldIndex) => (
                    <div
                      key={fieldIndex}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "3%",
                      }}
                    >
                      {fieldIndex === 0 ? (
                        <span style={{ width: "50px" }}></span>
                      ) : (
                        <span
                          style={{
                            padding: "10px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(0,0,0,.1)",
                            marginRight: "10px",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: "12px",
                            border: "solid 3px #b0ff45",
                          }}
                        >
                          OR
                        </span>
                      )}
                      {selectedComponent &&
                        selectedComponent[groupIndex] &&
                        React.createElement(
                          componentMapping[
                          selectedComponent[groupIndex].component
                          ],
                          {
                            ...selectedComponent[groupIndex].props,
                            value: groups[groupIndex].values[fieldIndex] || "",
                            onChange: (event) => {
                              const updatedValue = event.target.value;
                              const updatedGroups = [...groups];
                              updatedGroups[groupIndex].internalErrors[
                                fieldIndex
                              ] = "";
                              updatedGroups[groupIndex].values[fieldIndex] =
                                updatedValue;
                              setGroups(updatedGroups);
                            },
                            optionKey: group.selectedOption, // Pass the selected option key to the Select component
                          }
                        )}
                      {group.internalErrors[fieldIndex] === "" ? null : (
                        <span
                          style={{
                            color: "red",
                            marginLeft: "1%",
                            height: "5px",
                          }}
                        >
                          {group.internalErrors[fieldIndex]}
                        </span>
                      )}
                      {selectedComponent[groupIndex].type !== "datepicker" ? (
                        fieldIndex === group.values.length - 1 ? (
                          <Tooltip placement="top" title={<h6>Add Fields</h6>}>
                            <IconButton onClick={() => addFields(groupIndex)}>
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip placement="top" title={<h6>Remove Fields</h6>}>
                            <IconButton
                              onClick={() => removeFields(groupIndex, fieldIndex)}
                            >
                              <RemoveCircleOutlineRounded />
                            </IconButton>
                          </Tooltip>
                        )
                      ) : null}
                    </div>
                  ))}
                </Grid>
              </Grid>
              {/* <hr /> */}
            </div>
          ))}
        </Box>

        <Box sx={{ display: "flex", width: 100 - toggleWidth + "%" }}>
          <Grow
            in={checked}
            style={{ transformOrigin: "0 0 0" }}
            {...(checked ? { timeout: 1000 } : {})}
          >
            {groups && groups.length ? (
              <div
                style={{
                  marginLeft: "30px",
                  padding: "2%",
                  borderRadius: "5px",
                  border: "solid #dddddd",
                }}
              >
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <CopyToClipboard
                    text={JSON.stringify(
                      groups.map(({ selectedOption, values }) => {
                        const sanitizedValues = values.map((value) => {
                          if (typeof value === "object" && value !== null) {
                            const sanitizedValue = { ...value };
                            if (sanitizedValue && sanitizedValue.db_fields) {
                              delete sanitizedValue.db_fields;
                            }

                            return sanitizedValue;
                          }
                          return value;
                        });

                        return {
                          selectedOption,
                          values: sanitizedValues,
                        };
                      }),
                      null,
                      2
                    )}
                  >
                    <Tooltip title="Copy to Clipboard" arrow placement="top">
                      <RemoveCircleOutlineRounded
                        style={{ cursor: "pointer", alignSelf: "right" }}
                      />
                    </Tooltip>
                  </CopyToClipboard>
                  <Tooltip title="Edit" arrow placement="top">
                    <EditOutlined
                      style={{ cursor: "pointer", alignSelf: "right" }}
                      onClick={() => setIsEditable(!isEditable)}
                    />
                  </Tooltip>
                </div>
                {isEditable ? (
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Paste Filters"
                    multiline
                    rows={10}
                    style={{ width: "100%" }}
                    onChange={(event) => handleJSONPaste(event.target.value)}
                  />
                ) : (
                  <pre>
                    <code>
                      {JSON.stringify(
                        groups.map(({ selectedOption, values }) => {
                          const sanitizedValues = values.map((value) => {
                            if (typeof value === "object" && value !== null) {
                              const sanitizedValue = { ...value };
                              delete sanitizedValue.db_fields;
                              return sanitizedValue;
                            }
                            return value;
                          });

                          return {
                            selectedOption,
                            values: sanitizedValues,
                          };
                        }),
                        null,
                        2
                      )}
                    </code>
                  </pre>
                )}
              </div>
            ) : (
              <div></div>
            )}
          </Grow>
        </Box>
      </div>
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <Button
          onClick={handleSubmit}
          variant="outlined"
          style={{ width: "300px" }}
        >
          Submit Search
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          style={{ width: "300px" }}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default ConditionalFilter;
